import { useState, useEffect } from "react";
import { useSelections } from "../context/Selections";

export const useOverviewData = (app) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const { selections } = useSelections();

  useEffect(() => {
    const fetchData = async () => {
      if (!app) return;

      setIsLoading(true);
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        setData({});
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [app, selections]);

  return { data, isLoading };
};
